import React, { useState } from 'react';
import '../styles/Contact.scss'; // Ensure you have the appropriate styles
import axiosInstance from "../utils/axios";
import { toast } from 'react-toastify';

const Contact = () => {
  const [email, setEmail] = useState('');
const [loading, setLoading] = useState(false);
const [message, setMessage] = useState('');

const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const response = await axiosInstance.post('/subscription/subscription/subscribe/', { email });

    if (response.status === 200 || response.status === 201) {
      toast.success(response.data.message || 'Successfully subscribed!');
      setEmail('');
    }
  } catch (error) {
    // Check if error response exists (API returned an error status)
    if (error.response?.status === 409 || error.response?.status === 400) {
      const errorMessage = error.response?.data?.email?.[0] || error.response?.data?.message || 'Already subscribed';
      toast.error(errorMessage);
    } else {
      toast.error(error.message || 'An error occurred');
    }
  } finally {
    setLoading(false);
  }
};

  return (
    <section className="contact">
      <div className="container">
        <h2 className="title">GET UPDATE SUBSCRIBE NOW !</h2>
        <form className="form" onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your Email ID Here"
            className="input"
            required
          />
          <button type="submit" className="submit">
            Submit
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
